import { CSSProperties, PropsWithChildren } from 'react';

import * as S from './style';

export interface RowProps {
  title: string;
  alignItems?: CSSProperties['alignItems'];
}

export default function Row({ children, title, alignItems }: PropsWithChildren<RowProps>) {
  return (
    <S.Wrapper>
      {title && <S.Title>{title}</S.Title>}
      <S.Body alignItems={alignItems}>{children}</S.Body>
    </S.Wrapper>
  );
}
